import { ECartActionType, TCartState } from './domain';

export const DEFAULT_CART_STATE: TCartState = {
    cart_id: '',
    cart: null,
    removedCartItems: [],
    expiredCartItems: [],
    loading: { actionType: ECartActionType.GET_CART, state: true },
    error: { actionType: ECartActionType.GET_CART, message: '' },
    success: { actionType: ECartActionType.GET_CART, message: '' },
    tips: 0,
    cartToastIsShown: false,
};
